
export const restaurantList = async (welletContext, marketSetupId) => {
  return await welletContext.apis.tickets.get(`/shows/simple/name?marketid=${marketSetupId}`);
};

